// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3448":"8bc7902b","5617":"6df66dca","6211":"6df66dca","6758":"6df66dca","7022":"8bc7902b"}[chunkId] + ".chunk.css";
};